/** Helpers for WebVTT (.vtt) upload validation in AI Prescription voice search */

export const MAX_VTT_FILE_BYTES = 2 * 1024 * 1024; // 2 MB

export const isVttFileName = (name: string): boolean =>
  /\.vtt$/i.test(name?.trim() ?? "");

export const isValidWebVttHeader = (text: string): boolean => {
  const first = text.trimStart().slice(0, 6).toUpperCase();
  return first.startsWith("WEBVTT");
};
